import { Link } from "react-router-dom";
import { useState } from "react";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="container-nav">
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img
            src="/logo.png"
            alt="Logo da GR Mármores"
            className="logo"
          />
        </Link>

        {/* Botão Mobile */}
        <button
          className="menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menu"
        >
          ☰
        </button>

        {/* Menu */}
        <ul className={`nav ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/marmore" onClick={() => setMenuOpen(false)}>
              Mármore
            </Link>
          </li>
          <li>
            <Link to="/granito" onClick={() => setMenuOpen(false)}>
              Granito
            </Link>
          </li>
          <li>
            <Link to="/contacto" onClick={() => setMenuOpen(false)}>
              Contactos
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
